export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const ALL_RESPONSES = 'allResponses';
export const CURRENT_RESPONSES = 'currentResponses';
export const BACKWARD_CLICK_RESPONSE = 'backwardClickResponse';
export const FORWARD_CLICK_RESPONSE = 'forwardClickResponse';
export const EDIT_RESPONSES = 'editResponses';
